import { useMemo } from "react";
import { useDrawdownData } from "@repo/api";
import type { DrawdownDataPoint } from "../../types/strategy-detail";

export const useDrawdown = () => {
  const drawdownData = useDrawdownData();
  const drawdownTimeseries = useMemo(() => {
    if (drawdownData.data && drawdownData.data.Strategy) {
      return Object.keys(drawdownData.data.Strategy).map(
        (date) =>
          ({
            date,
            drawdown: drawdownData.data!.Strategy[date] * 100,
          } as DrawdownDataPoint)
      );
    } else {
      return [];
    }
  }, [drawdownData.data]);

  // Helper function to detect empty data
  const isEmptyData = (data: unknown): boolean => {
    if (!data) return true;
    if (Array.isArray(data) && data.length === 0) return true;
    if (typeof data === "object" && Object.keys(data).length === 0) return true;
    return false;
  };

  const isDataEmpty = isEmptyData(drawdownData.data);

  return {
    ...drawdownData,
    data:
      drawdownData.data && drawdownData.data.Strategy ? drawdownTimeseries : [],
    isLoading: drawdownData.isLoading || isDataEmpty,
  };
};
